import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { typographyStyles } from "constants/styles";
import { IIncomeEntryArticleBundle } from "types";

interface IncomeEntryBundleEditDialogProps {
  bundle: IIncomeEntryArticleBundle | null;
  onClose: () => void;
  onSave: (bundle: IIncomeEntryArticleBundle) => void;
}

export default function IncomeEntryBundleEditDialog({
  bundle,
  onClose,
  onSave,
}: IncomeEntryBundleEditDialogProps) {
  const [amount, setAmount] = useState("");
  const [availableAmount, setAvailableAmount] = useState("");
  const [lote, setLote] = useState("");

  useEffect(() => {
    if (bundle) {
      setAmount(String(bundle.amount ?? 0));
      setAvailableAmount(String(bundle.amount_available ?? 0));
      setLote(bundle.lote ?? "");
    }
  }, [bundle]);

  if (!bundle) return null;

  const handleSave = () => {
    onSave({
      ...bundle,
      amount: Number(amount),
      amount_available: Number(availableAmount),
      lote: lote || null,
    });
  };

  return (
    <Dialog open={!!bundle} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>
        Editar fardo{" "}
        <Typography
          component="span"
          sx={typographyStyles.monospace}
          color="text.secondary"
        >
          F-{bundle.lote_externo}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Lote interno"
            value={lote}
            onChange={(e) => setLote(e.target.value)}
            fullWidth
          />
          <TextField
            type="number"
            label="Cantidad física"
            value={amount}
            onChange={(e) => {
              const value = e.target.value === ""
                ? ""
                : String(Math.max(Number(e.target.value) || 0, 0));
              setAmount(value);
              setAvailableAmount(value);
            }}
            inputProps={{ min: 0 }}
            fullWidth
          />
          <TextField
            type="number"
            label="Cantidad Disponible"
            value={availableAmount}
            onChange={(e) => {
              const value = e.target.value === ""
                ? ""
                : String(Math.min(Math.max(Number(e.target.value) || 0, 0), Number(amount)));
              setAvailableAmount(value);
            }}
            inputProps={{ min: 0, max: amount }}
            fullWidth
          />
          <Typography
            variant="body2"
            color={
              Number(availableAmount) < Number(amount)
                ? "warning.main"
                : "text.secondary"
            }
          >
            Cantidad no disponible: {Number(amount) - Number(availableAmount)} un.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleSave}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
